import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class AuthorInfo extends React.PureComponent {
    static propTypes = {
        wemediaEAccountId: PropTypes.string,
        fhhAccountDetail: PropTypes.object,
    };

    state = {};

    componentDidMount() {}

    render() {
        const { wemediaEAccountId, fhhAccountDetail } = this.props;

        return (
            <div className={styles.authorInfo}>
                <div
                    className={`${styles.userNameWrapper} ${
                        fhhAccountDetail.description ? '' : styles.spaceReduce
                    } clearfix`}>
                    {fhhAccountDetail.logo && (
                        <div className={styles.headImg}>
                            <a href={`https://ishare.ifeng.com/mediaShare/home/${wemediaEAccountId}/media`}>
                                <img src={fhhAccountDetail.logo} target="_blank" alt="" />
                            </a>
                        </div>
                    )}
                    {fhhAccountDetail.weMediaName && (
                        <div className={styles.userName}>
                            <a
                                href={`https://ishare.ifeng.com/mediaShare/home/${wemediaEAccountId}/media`}
                                target="_blank"
                                rel="noopener noreferrer">
                                {fhhAccountDetail.weMediaName}
                            </a>
                        </div>
                    )}
                    {fhhAccountDetail.weMediaName && (
                        <div className={styles.follow}>
                            <div className={styles.qrcode}>
                                <div className={styles.qrCodeImg}>
                                    <img
                                        src={'http://p1.ifengimg.com/a/2019/0325/c60e85b34c5d90asize22_w100_h100.png'}
                                        alt=""
                                    />
                                </div>
                                <div className={styles.textWrapper}>
                                    <p>
                                        下载客户端<br />独家抢先看
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {fhhAccountDetail.description && <p className={styles.summery}>{fhhAccountDetail.description}</p>}
            </div>
        );
    }
}

export default errorBoundary(AuthorInfo);
